import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-credit"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "业务员名称", -1);

const _hoisted_5 = {
  class: "wrapper supplier"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "待回款客户数量", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "逾期客户数量", -1);

const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("新增授信业务员");

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#999",
    "margin-left": "10px"
  }
}, "授信业务员可为客户授信时选择团队垫资结算", -1);

const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "credit-limit-cell"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "待回款订单金额", -1);

const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 0,
  style: {
    "color": "#67C23A"
  }
};
const _hoisted_24 = {
  key: 1,
  style: {
    "color": "#F56C6C"
  }
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode("禁用");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("启用");

import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getSalemanSupplier } from '@/request';
import SalesmanModal from '../components/salesman-modal.vue';
import CreditLimitModal from '../components/credit-limit-modal.vue';
import Axios from '@/request/createAxiosInstalce';
import { ElMessageBox, ElMessage } from 'element-plus';
import { Edit, WarningFilled } from '@element-plus/icons-vue';
export default {
  name: 'index',

  setup(__props) {
    onMounted(() => getOptions());
    const router = useRouter();
    const custOptions = [{
      name: '全部',
      value: ''
    }, {
      name: '客户数量 > 0',
      value: '1'
    }, {
      name: '客户数量 = 0',
      value: '0'
    }];
    const supplierList = ref([]);
    const search = reactive({
      userKeyword: '',
      supplierId: '',
      repaymentingCustCount: '',
      expireCustCount: ''
    });
    const salesmanModalShow = ref(false);
    const creditLimitModalShow = ref(false);
    const currentSalesman = ref(null);
    const init = ref(false);

    function getOptions() {
      getSalemanSupplier().then(res => {
        supplierList.value = res.data;
      }).finally(() => init.value = true);
    }

    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '业务员',
        field: 'linkMan'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }, {
        title: '授信额度',
        field: 'creditLimitAmount',
        slots: {
          default: 'creditLimitAmount'
        }
      }, {
        title: '当前剩余额度',
        field: 'remainCreditAmount'
      }, {
        title: '授信客户数量',
        field: 'creditCustCount',
        slots: {
          default: 'creditCustCount'
        }
      }, {
        title: '授信订单金额',
        field: 'creditBillAmountTotal',
        slots: {
          default: 'creditBillAmountTotal'
        }
      }, {
        title: '待回款客户数量',
        field: 'repaymentingCustCount',
        slots: {
          default: 'repaymentingCustCount'
        }
      }, {
        title: '待回款订单金额',
        field: 'repaymentingAmountTotal',
        slots: {
          default: 'repaymentingAmountTotal',
          header: 'repaymentingAmountTotalHeader'
        }
      }, {
        title: '逾期客户数量',
        field: 'expireCustCount',
        slots: {
          default: 'expireCustCount'
        }
      }, {
        title: '逾期订单金额',
        field: 'expireAmountTotal',
        slots: {
          default: 'expireAmountTotal'
        }
      }, {
        title: '授信权限',
        field: 'creditStatus',
        slots: {
          default: 'creditStatus'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 100
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = {
              userKeyword: search.userKeyword,
              repaymentingCustCount: search.repaymentingCustCount,
              expireCustCount: search.expireCustCount,
              page: page.currentPage,
              pageSize: page.pageSize
            };

            if (search.supplierId) {
              params.supplierIds = search.supplierId;
            } else {
              params.supplierIds = supplierList.value.map(v => v.supplier_id).join();
            }

            Axios.get('/admin/creditManage/creditUser/list', {
              params
            }).then(res => {
              console.log(res);
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });

    function addUserHandle(list) {
      Axios.post('/admin/creditManage/creditUser/add', list.map(v => v.supUserId)).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function updateHandle(supUserId, enable) {
      let url = `/admin/creditManage/creditUser/enable?supUserId=${supUserId}&enable=${enable}`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function reset() {
      Object.keys(search).forEach(key => search[key] = '');
      table.value.commitProxy('reload');
    }

    function toCust(value, custIds) {
      if (value == 0) return;
      router.push({
        name: 'creditCust',
        query: {
          custIds
        }
      });
    }

    function openEditLimit(row) {
      currentSalesman.value = _objectSpread({}, row);
      creditLimitModalShow.value = true;
    }

    function limitSaveSuccess() {
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.userKeyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.userKeyword = $event),
        placeholder: "请输入名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: search.supplierId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.supplierId = $event),
        placeholder: "请选择团队",
        style: {
          "width": "200px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            value: item.supplier_id,
            label: item.supplier_name,
            key: item.supplier_id
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.repaymentingCustCount,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.repaymentingCustCount = $event),
        style: {
          "width": "140px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(custOptions, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_select, {
        modelValue: search.expireCustCount,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.expireCustCount = $event),
        style: {
          "width": "140px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(custOptions, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => salesmanModalShow.value = true)
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _hoisted_14]), init.value ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
        key: 0,
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        creditCustCount: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.creditCustCount > 0
          }),
          onClick: $event => toCust(row.creditCustCount, row.creditCustIds)
        }, _toDisplayString(row.creditCustCount), 11, _hoisted_15)]),
        creditBillAmountTotal: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.creditBillAmountTotal > 0
          }),
          onClick: $event => toCust(row.creditCustCount, row.creditCustIds)
        }, _toDisplayString(row.creditBillAmountTotal), 11, _hoisted_16)]),
        creditLimitAmount: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(row.isCreditLimited === 1 ? row.creditLimitAmount : '不限制') + " ", 1), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: $event => openEditLimit(row)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onClick"])])]),
        repaymentingCustCount: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.repaymentingCustCount > 0
          }),
          onClick: $event => toCust(row.repaymentingCustCount, row.repaymentingCustIds)
        }, _toDisplayString(row.repaymentingCustCount), 11, _hoisted_18)]),
        repaymentingAmountTotal: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.repaymentingAmountTotal > 0
          }),
          onClick: $event => toCust(row.repaymentingAmountTotal, row.repaymentingCustIds)
        }, _toDisplayString(row.repaymentingAmountTotal), 11, _hoisted_19)]),
        repaymentingAmountTotalHeader: _withCtx(() => [_hoisted_20, _createVNode(_component_el_tooltip, {
          content: "不含待入账金额",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-left": "4px",
              "vertical-align": "middle"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
            _: 1
          })]),
          _: 1
        })]),
        expireCustCount: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.expireCustCount > 0
          }),
          onClick: $event => toCust(row.expireCustCount, row.expireCustIds)
        }, _toDisplayString(row.expireCustCount), 11, _hoisted_21)]),
        expireAmountTotal: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: _normalizeClass({
            active: row.expireAmountTotal > 0
          }),
          onClick: $event => toCust(row.expireAmountTotal, row.expireCustIds)
        }, _toDisplayString(row.expireAmountTotal), 11, _hoisted_22)]),
        creditStatus: _withCtx(({
          row
        }) => [row.creditStatus == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_23, "正常")) : (_openBlock(), _createElementBlock("span", _hoisted_24, "禁用"))]),
        operation: _withCtx(({
          row
        }) => [row.creditStatus == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          size: "small",
          onClick: $event => updateHandle(row.supUserId, '0')
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          size: "small",
          onClick: $event => updateHandle(row.supUserId, '1')
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 2
        }, 1032, ["onClick"]))]),
        _: 1
      }, 16)) : _createCommentVNode("", true), _createVNode(SalesmanModal, {
        modelValue: salesmanModalShow.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => salesmanModalShow.value = $event),
        supplierList: supplierList.value,
        onSuccess: addUserHandle
      }, null, 8, ["modelValue", "supplierList"]), _createVNode(CreditLimitModal, {
        modelValue: creditLimitModalShow.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => creditLimitModalShow.value = $event),
        currentSalesman: currentSalesman.value,
        onSuccess: limitSaveSuccess
      }, null, 8, ["modelValue", "currentSalesman"])]);
    };
  }

};